import Vue from 'vue'
import Router from 'vue-router'
// 公共组件 侧边栏 顶部 底部
import wechat_main from '@/views/wechat/main'

Vue.use(Router);
const router = new Router({
    mode: "history",
    routes: [
        {
            path: '/',
            redirect: '/wechat/home',
            name: 'wechat_main',
            component: wechat_main,
            meta: {
                requireAuth: true
            },
            children: [
                {
                    path: "/wechat",
                    redirect: '/wechat/home',
                    meta:{
                        title:'我的设备'
                    }
                },
                {
                    path: '/wechat/weiSmStatus',
                    name: 'weiSmStatus',
                    component: () => import ('@/views/wechat/weiSmStatus.vue'),
                    meta:{
                        title:'实名结果'
                    }
                },
                {
                    path: '/wechat/Rechargerecord',
                    name: 'Rechargerecord',
                    component: () => import ('@/views/wechat/Rechargerecord.vue'),
                    meta:{
                        title:'订购记录'
                    }
                },
                {
                    path: '/wechat/packageRecharge',
                    name: 'packageRecharge',
                    component: () => import ('@/views/wechat/packageRecharge.vue'),
                    meta:{
                        title:'套餐续期'
                    }
                },
                {
                    path: '/wechat/comproblem',
                    name: 'comproblem',
                    component: () => import ('@/views/wechat/comproblem.vue'),
                    meta:{
                        title:'常见问题'
                    }
                },
                {
                    path: '/wechat/home',
                    name: 'home',
                    component: () => import ('@/views/wechat/home.vue'),
                    meta:{
                        title:'我的设备'
                    }
                },
                {
                    path: '/wechat/Recharge',
                    name: 'Recharge',
                    component: () => import ('@/views/wechat/Recharge.vue'),
                    meta:{
                        title:'套餐续期'
                    }
                },
                {
                    path: '/wechat/changeDevice',
                    name: 'changeDevice',
                    component: () => import ('@/views/wechat/changeDevice.vue'),
                    meta:{
                        title:'切换/新增设备'
                    }
                },
                {
                    path: '/wechat/AuthenticationDx',
                    name: 'AuthenticationDx',
                    component: () => import ('@/views/wechat/AuthenticationDx.vue'),
                    meta:{
                        title:'用户服务平台'
                    }
                },
                {
                    path:'/wechat/RealGuidePage',
                    name: 'AuthenticationDx',
                    component: () => import ('@/views/wechat/homepage/RealGuidePage.vue'),
                    meta:{
                        title:'实名引导页'
                    }
                },
                {
                    path:'/wechat/UnicomRealName',
                    name: 'UnicomRealName',
                    component: () => import ('@/views/wechat/homepage/UnicomRealName.vue'),
                    meta:{
                        title:'联通实名引导页'
                    }
                },
                {
                    path:'/wechat/NetworkSwitch',
                    name: 'NetworkSwitch',
                    component: () => import ('@/views/wechat/homepage/NetworkSwitch.vue'),
                    meta:{
                        title:'网络切换'
                    }
                },
                {
                    path:'/wechat/VirtualAuth',
                    name: 'VirtualAuth',
                    component: () => import ('@/views/wechat/homepage/VirtualAuth.vue'),
                    meta:{
                        title:'一键认证'
                    }
                },
                {
                    path:'/wechat/RegularPackage',
                    name: 'RegularPackage',
                    component: () => import ('@/views/wechat/RegularPackage.vue'),
                    meta:{
                        title:'套餐续期'
                    }
                },
                {
                    path:'/wechat/BasePackage',
                    name: 'BasePackage',
                    component: () => import ('@/views/wechat/BasePackage.vue'),
                    meta:{
                        title:'套餐续期'
                    }
                },
                {
                    path:'/wechat/FuelBag',
                    name: 'FuelBag',
                    component: () => import ('@/views/wechat/FuelBag.vue'),
                    meta:{
                        title:'加油包'
                    }
                },
                {
                    path:'/wechat/DeviceInfor',
                    name: 'DeviceInfor',
                    component: () => import ('@/views/wechat/DeviceInfor.vue'),
                    meta:{
                        title:'智能检测'
                    }
                },
                {
                    path:'/wechat/SaveFlowGuide',
                    name: 'SaveFlowGuide',
                    component: () => import ('@/views/wechat/homepage/SaveFlowGuide.vue'),
                    meta:{
                        title:'省流量设置指南'
                    }
                },
                {
                    path:'/wechat/ApplyForInvoice',
                    name: 'ApplyForInvoice',
                    component: () => import ('@/views/wechat/ApplyForInvoice.vue'),
                    meta:{
                        title:'申请发票'
                    }
                },
                
            ]
        },
    ]
});

const defaultTitle = '用户服务平台'; 
// 未登录路由拦截
router.beforeEach((to, from, next) => {
    //路由设置
    document.title = to.meta.title ? to.meta.title : defaultTitle;
    next()
});


// 当在渲染一个路由的过程中，需要尝试解析一个异步组件时发生错误
router.onError((error) => {
    console.log('error:'+ error.message); 
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    if (isChunkLoadFailed) {
      window.location.reload();
    }else{
      console.log(error)
    }
});
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}




export default router



// WEBPACK FOOTER //
// ./src/router/index.js